import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import NoPaddingLoadingButton from "./NoPaddingBtnComponents/NoPaddingLoadingButton";
import NoPaddingBtnWithIcons from "./NoPaddingBtnComponents/NoPaddingBtnWithIcons";
import NoPaddingButtonWithEndIcon from "./NoPaddingBtnComponents/NoPaddingButtonWithEndIcon";
import NoPaddingButtonWithStartIcon from "./NoPaddingBtnComponents/NoPaddingButtonWithStartIcon";
import NoPaddingButtonDisabled from "./NoPaddingBtnComponents/NoPaddingButtonDisabled";
import NoPaddingButtonSmall from "./NoPaddingBtnComponents/NoPaddingButtonSmall";
import NoPaddingButtonMedium from "./NoPaddingBtnComponents/NoPaddingButtonMedium";
import NoPaddingButtonLarge from "./NoPaddingBtnComponents/NoPaddingButtonLarge";

const NoPaddingButtons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          NoPadding Button
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          this is the button with lighter shade of background color.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <NoPaddingButtonLarge />
          </Grid>
          <Grid item xs={6}>
            <NoPaddingButtonMedium />
          </Grid>
          <Grid item xs={6}>
            <NoPaddingButtonSmall />
          </Grid>
          <Grid item xs={6}>
            <NoPaddingButtonDisabled />
          </Grid>
          <Grid item xs={6}>
            <NoPaddingButtonWithStartIcon />
          </Grid>
          <Grid item xs={6}>
            <NoPaddingButtonWithEndIcon />
          </Grid>
          <Grid item xs={6}>
            <NoPaddingBtnWithIcons />
          </Grid>
          <Grid item xs={6}>
            <NoPaddingLoadingButton />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default NoPaddingButtons;
